import { render, staticRenderFns } from "./TrainingDateForm.vue?vue&type=template&id=2b50f960&"
import script from "./TrainingDateForm.vue?vue&type=script&lang=js&"
export * from "./TrainingDateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports